export default __webpack_public_path__ + "static/media/ReportHeader.718c36a1.jpg";